import { AddOutlined, LockOutlined, Logout, Password } from "@mui/icons-material";
import { useDialog } from "../libs/dialog/DialogProvider";
import { IconButton } from "@mui/material";
import NewPassword from "./dialogs/NewPassword";
import ChangePassword from "./dialogs/ChangePassword";
import LogoutDlg from "../dialogs/LogoutDlg";
export default function(){
    const {openDialog} = useDialog()
    const onAdd = () => openDialog({id:"new",children:<NewPassword/>})
    const onPass = () => openDialog({id:"new",children:<ChangePassword/>})
    const onLogout = () => openDialog({id:"logout",children:<LogoutDlg/>})
    return <header>
        <div className="flex middle between content">
            <div className="flex middle gap-8">
                <LockOutlined/>
                <b>PASSWORDS</b>
            </div>
            <div className="flex middle gap-8">
                <IconButton onClick={onAdd}><AddOutlined/></IconButton>
                <IconButton onClick={onPass}><Password/></IconButton>
                <IconButton onClick={onLogout}><Logout/></IconButton>
            </div>
        </div>
    </header>
}